/**
 * pn-gallery.js — mobile carousel counter + dot indicator for the PDP media gallery.
 * Watches every slide in .product__media-list.slider--mobile and updates:
 *   - .slider-counter--current text
 *   - .pn-pdp-gallery__dot[aria-current] state
 * Runs only on the PDP; no-ops on desktop where the gallery is stacked.
 */
(function () {
  'use strict';

  function initGallery(mediaGallery) {
    const slider = mediaGallery.querySelector('.product__media-list.slider--mobile');
    if (!slider) return;
    const slides = slider.querySelectorAll('.product__media-item');
    if (slides.length === 0) return;

    const counter = mediaGallery.querySelector('.slider-counter--current');
    const totalNode = mediaGallery.querySelector('.slider-counter--total');
    if (totalNode) totalNode.textContent = String(slides.length);

    let dots = mediaGallery.querySelector('.pn-pdp-gallery__dots');
    if (!dots) {
      dots = document.createElement('ol');
      dots.className = 'pn-pdp-gallery__dots';
      // NOTE: deliberately NOT role="tablist"/"tab". These are carousel dots — there are no
      // tabpanels and no arrow-key tab navigation, so claiming tab semantics both misleads
      // assistive tech and fails axe three ways: aria-required-children (the <li> sits between
      // the tablist and its tabs), aria-required-parent (each tab parent is an <li>), and
      // listitem (an <li> under role="tablist" is not semantically a list item).
      // A plain <ol> of labelled buttons is honest, passes, and behaves identically.
      dots.setAttribute('aria-label', 'Gallery navigation');
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slides.forEach((_slide, i) => {
        if (!slides[i].id) slides[i].id = 'pn-slide-' + Math.random().toString(36).slice(2, 8) + '-' + i;
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'View image ' + (i + 1));
        btn.setAttribute('aria-controls', slides[i].id);
        btn.className = 'pn-pdp-gallery__dot';
        if (i === 0) btn.setAttribute('aria-current', 'true');
        btn.addEventListener('click', function () {
          slides[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        });
        li.appendChild(btn);
        dots.appendChild(li);
      });
      const buttons = mediaGallery.querySelector('.slider-buttons');
      if (buttons) buttons.parentNode.insertBefore(dots, buttons.nextSibling);
      else mediaGallery.appendChild(dots);
    }

    const dotButtons = dots.querySelectorAll('.pn-pdp-gallery__dot');

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio >= 0.6) {
              const idx = Array.prototype.indexOf.call(slides, entry.target);
              if (idx < 0) return;
              if (counter) counter.textContent = String(idx + 1);
              dotButtons.forEach(function (b, i) {
                if (i === idx) b.setAttribute('aria-current', 'true');
                else b.removeAttribute('aria-current');
              });
            }
          });
        },
        { root: slider, threshold: [0.6] }
      );
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
